const pageNameKey = "userCredentialsModal";

export const userCredentialsModalEn = {
  [pageNameKey]: {
    title: "User Credentials",
    warningText:
      "IMPORTANT: Save these credentials now. They will not be accessible again after closing this dialog.",
    userIdLabel: "User ID",
    keyIdLabel: "Key ID",
    privateKeyLabel: "Private Key",
    expirationDateLabel: "Expiration Date",
    downloadButton: "Download Credentials",
    closeButton: "Close",
    copySuccessText: "Copied to clipboard",
    copyTooltip: "Copy to clipboard",
  },
};

export const userCredentialsModalPtBr = {
  [pageNameKey]: {
    title: "Credenciais do usuário",
    warningText:
      "IMPORTANTE: Salve estas credenciais agora. Elas não estarão acessíveis novamente após fechar esta caixa de diálogo.",
    userIdLabel: "ID do usuário",
    keyIdLabel: "ID da chave",
    privateKeyLabel: "Chave privada",
    expirationDateLabel: "Data de validade",
    downloadButton: "Baixar credenciais",
    closeButton: "Fechar",
    copySuccessText: "Copiado para a área de transferência",
    copyTooltip: "Copiar para a área de transferência",
  },
};

export const userCredentialsModalDe = {
  [pageNameKey]: {
    title: "Benutzeranmeldeinformationen",
    warningText:
      "WICHTIG: Speichern Sie diese Anmeldeinformationen jetzt. Sie sind nach dem Schließen dieses Dialogs nicht mehr zugänglich.",
    userIdLabel: "Benutzer-ID",
    keyIdLabel: "Schlüssel-ID",
    privateKeyLabel: "Privater Schlüssel",
    expirationDateLabel: "Ablaufdatum",
    downloadButton: "Anmeldeinformationen herunterladen",
    closeButton: "Schließen",
    copySuccessText: "In die Zwischenablage kopiert",
    copyTooltip: "In die Zwischenablage kopieren",
  },
};

export const userCredentialsModalZhHans = {
  [pageNameKey]: {
    title: "用户凭据",
    warningText: "重要提示：请立即保存这些凭据。关闭此对话框后将无法再次访问。",
    userIdLabel: "用户ID",
    keyIdLabel: "密钥ID",
    privateKeyLabel: "私钥",
    expirationDateLabel: "到期日期",
    downloadButton: "下载凭据",
    closeButton: "关闭",
    copySuccessText: "已复制到剪贴板",
    copyTooltip: "复制到剪贴板",
  },
};

export const userCredentialsModalIt = {
  [pageNameKey]: {
    title: "Credenziali utente",
    warningText:
      "IMPORTANTE: Salva queste credenziali ora. Non saranno più accessibili dopo aver chiuso questa finestra di dialogo.",
    userIdLabel: "ID utente",
    keyIdLabel: "ID chiave",
    privateKeyLabel: "Chiave privata",
    expirationDateLabel: "Data di scadenza",
    downloadButton: "Scarica credenziali",
    closeButton: "Chiudi",
    copySuccessText: "Copiato negli appunti",
    copyTooltip: "Copia negli appunti",
  },
};

export const userCredentialsModalEs = {
  [pageNameKey]: {
    title: "Credenciales de usuario",
    warningText:
      "IMPORTANTE: Guarda estas credenciales ahora. No volverán a estar accesibles después de cerrar este diálogo.",
    userIdLabel: "Usuario ID",
    keyIdLabel: "Clave ID",
    privateKeyLabel: "Clave privada",
    expirationDateLabel: "Fecha de vencimiento",
    downloadButton: "Descargar credenciales",
    closeButton: "Cerrar",
    copySuccessText: "Copiado al portapapeles",
    copyTooltip: "Copiar al portapapeles",
  },
};

export const userCredentialsModalNl = {
  [pageNameKey]: {
    closeButton: "Sluiten",
    copySuccessText: "Naar klembord gekopieerd",
    copyTooltip: "Naar klembord kopiëren",
    downloadButton: "Gegevens downloaden",
    expirationDateLabel: "Vervaldatum",
    keyIdLabel: "Sleutel-ID",
    privateKeyLabel: "Privésleutel",
    title: "Gebruikersgegevens",
    userIdLabel: "Gebruikers-ID",
    warningText:
      "BELANGRIJK: Sla deze gegevens nu op. Na het sluiten van dit venster zijn ze niet meer toegankelijk.",
  },
};

export const userCredentialsModalTr = {
  [pageNameKey]: {
    closeButton: "Kapat",
    copySuccessText: "Panoya kopyalandı",
    copyTooltip: "Panoya kopyala",
    downloadButton: "Kimlik Bilgilerini İndir",
    expirationDateLabel: "Son kullanma tarihi",
    keyIdLabel: "Anahtar Kimliği",
    privateKeyLabel: "Özel Anahtar",
    title: "Kullanıcı Kimlik Bilgileri",
    userIdLabel: "Kullanıcı kimliği",
    warningText:
      "ÖNEMLİ: Bu kimlik bilgilerini şimdi kaydedin. Bu iletişim kutusunu kapattıktan sonra bunlara tekrar erişilemeyecek.",
  },
};
